import Icon, { Icons } from '@/components/elements/Icon';

export function SettingsButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="border-transparent p-1 rounded-md -mr-1 hover:border-gray-300 border transition-colors"
    >
      <Icon name={Icons.GEAR} size={24} />
    </button>
  );
}

export default SettingsButton;
